import React from "react";
import EiaButton from "./EiaButton";

const EiaCopyButton = function (props) {

    const {textToCopy} = props

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            console.log('Copied to clipboard:', textToCopy);
        } catch (err) {
            console.error('Error while copying to clipboard:', err);
        }
    };

    return (
        <EiaButton onClick={handleCopy} tooltip={"Copies text to clipboard"}>Copy</EiaButton>
    );
}
export default EiaCopyButton;